import React from "react";
import { Field, getIn } from "formik";
import { translate } from "react-i18next";
const ErrorMessage = ({ name, trans, t }) => (
  <Field
    className = "w3-text-red" 
    name={name}
    render={({ form }) => {
      const error = getIn(form.errors, name);
      const touch = getIn(form.touched, name);
      return touch && error ? <div  className = "w3-text-red" >{t(`${error}`) }</div> : null;
    }}
  />
);

export default translate("create_order")(ErrorMessage);
